// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1PVJU","signatureBlock":"Footer_signatureBlock__3Rp82","signature":"Footer_signature__nIJFV"};